<template>
  <div class="settings-wrapper">
    <b-container
      tag="section"
      class="settings-cont">
      <b-row>
        <b-col
          sm="12"
          md="10"
          offset-md="1"
          class="mb-5">
          <router-view/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Settings',
};
</script>
